<template>
  <div class="wrap">
    <div class="card-wrap">
      <div class="banner">
        <img :alt="name" :src="'/static/img/aboutback.webp'" width="100%"/>
      </div>
      <a-card hoverable class="product-card">
        <div style="display:flex;align-items: center">
          <img :alt="name" :src="'/static/img/logo.png'" width="50px"/>
          <span class="title">{{name}}</span>
        </div>
        <div class="content">
          <p>※ 十年芯片行业，可信赖老店为您提供一站式服务</p>
          <p>※ 6位从事软硬件电路设计多年的工程师为您提供产品解决方案。</p>
          <p>※ 专业的团队提供线束的加工服务。</p>
          <p>※ 世界知名品牌的传感器、接口、内存、处理器，数据转换芯片的分销。</p>
          <p>※ 为仪器仪表、物联网、自动化行业提供线束、机壳、芯片 配单焊接组装、调试、全产业链服务。</p>
          <p>※ 响应速度快，原装正品，价格合理，现货库存，48小时交货。</p>
          <p>※ 北京、深圳、香港、全境提供7×24小时订货技术支持</p>
          <div style="width:100%">
            <img src="/static/img/jianjie.png" width="40%" alt="海源恒智" style="display: block;margin:10px auto;">
          </div>
          <h2>{{desc}}</h2>
          <h2>{{descMainProduct}}</h2>
          <div style="width:100%">
            <img src="/static/img/cardb.png" class="c-card" alt="海源恒智" style="display: block;margin:10px auto;">
          </div>
        </div>
      </a-card>
      <a-card class="product-card" title="工作现场">
        <div class="mainProduct">
          <a-card-grid
            v-for="e in 8"
            :key="e"
            style="textAlign:'center'"
            class="productWidth"
          >
          <img :src="'/static/img/xc/' + e + '.png'" :alt="'工作现场'" width="100%">
          </a-card-grid>
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
import appConf from "@/config/config";
const { name, desc, descMainProduct } = appConf;

export default {
  name: "About",
  data() {
    return {
      name,
      desc,
      descMainProduct
    };
  },
};
</script>
<style lang="css" scoped>
.title {
  font-size: 36px;
  margin-left: 2px;
}
.mainProduct {
  display: flex;
  flex-wrap: wrap;
}
.card-wrap {
  width: 100%;
  margin-bottom: 80px;
  display: flex;  
  flex-flow: column wrap;
  align-items: center;
  min-height: 100vh;
  overflow: hidden;
}
.banner {
  width: 100%;
  max-height: 250px;
}
.card-wrap .product-card {
  min-width: 300px;
  max-width: 1300px;
  width: 80%;
  margin: 20px;
  background-color: rgba(255, 255, 255, 0.85);
}
.content {
  padding: 20px;
  display: flex;
  flex-flow: column nowrap;
  min-height: 300px;  
}
.content p {
  font-weight: bold;
  font-size: 18px;
}
.c-card {
  width: 60%;
}
.productWidth {
  width: 25%;
}
@media screen and (max-width: 666px) {
  .title {
    font-size: 26px;
  }
  .banner {
    max-height: 300px;
  }
  .card-wrap {
    padding: 0;
    margin: 0 auto;
  }
  .card-wrap .product-card {
    width: 100%;
    margin: 0px;
  }
  .c-card {
    width: 100%;
  }
  .mainProduct {
    display: flex;
    flex-direction: column;
  }
  .productWidth {
    width: 100%;
  }
}
</style>
